import { ValidationType, RefType, SelectBlockOption, Language } from "../types";

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const validatePhone = (string: string) => {
  const pattern = new RegExp(
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3}$/im
  );
  return pattern.test(string);
};

export const validateEmail = (string: string) => {
  const pattern = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return pattern.test(string);
};

export const formatPostal = (string: string, prev: string) => {
  const pattern = new RegExp(/\d|-/g);
  if (pattern.test(string)) {
    if (string.length === 2 && prev.indexOf("-") === -1) {
      return `${string.substr(0, 2)}-${string.substr(3)}`;
    }
    return string;
  } else {
    return "";
  }
};

export const validatePostal = (string: string) => {
  const pattern = new RegExp(/\d{2}-\d{3}/);
  return pattern.test(string) && string.length === 6;
};

export const validateYear = (string: string) => {
  const pattern = new RegExp(/\d{4}$/);
  return pattern.test(string) && string.length === 4;
};

export const validateLength = (string: string, length = 3) => {
  return string.length >= length;
};

export function formValidation<T>(validation: ValidationType<T>, data: T) {
  let isValid = false;
  Object.keys(validation).forEach((key) => {
    const element = validation[key as keyof T];
    if (element.required) {
      isValid = element.valid(data[key as keyof T]);
    }
  });
  return isValid;
}

export const scrollTo = (element: RefType | undefined | null) => {
  if (element) {
    element.current?.scrollIntoView({
      behavior: "smooth",
    });
  }
};

export const returnActive = (data: SelectBlockOption[] | Language[]) => {
  return data.filter((item) => item.active);
};
